import { Children, isValidElement, useState, type ReactElement } from "react";
import type { WidgetComponent } from "@viz/presentation";

interface TabSpec { label: string }

const Tabs: WidgetComponent = ({ props, children }) => {
  const tabs = (props.tabs as TabSpec[] | undefined) ?? [];
  const [active, setActive] = useState(0);
  const arr = Children.toArray(children).filter(isValidElement) as ReactElement[];
  return (
    <div className="flex h-full flex-col">
      <div className="flex border-b border-slate-200">
        {tabs.map((t, i) => (
          <button
            key={i}
            onClick={() => setActive(i)}
            className={`px-4 py-2 text-sm ${i === active ? "border-b-2 border-sky-500 text-slate-900" : "text-slate-500 hover:text-slate-700"}`}
          >{t.label}</button>
        ))}
      </div>
      <div className="flex-1 overflow-auto">{arr[active] ?? null}</div>
    </div>
  );
};

export default Tabs;
